(() => {
document.addEventListener('click', event => {
  const purchase = event.target.closest('[data-gdc-purchase]');
  if (!purchase) return;
  const photo = purchase.querySelector('.gdc-selected-photo');
  const thumb = event.target.closest('[data-gdc-photo]');
  const showPhoto = url => { photo.src = url; photo.removeAttribute('srcset'); };
  if (thumb) { showPhoto(thumb.dataset.gdcPhoto); purchase.querySelectorAll('[data-gdc-photo]').forEach(item => item.setAttribute('aria-pressed', String(item === thumb))); }
  const stepper = event.target.closest('[data-gdc-quantity]');
  if (stepper) { const input = purchase.querySelector('[name=quantity]'); if (Number(stepper.dataset.gdcQuantity) > 0) input.stepUp(); else input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); }
  const dialog = purchase.querySelector('[data-gdc-photo-dialog]');
  if (event.target.closest('[data-gdc-zoom]')) { dialog.querySelector('img').src = photo.src; dialog.showModal(); }
  if (event.target.closest('[data-gdc-photo-close]') || event.target === dialog) dialog.close();
});
document.addEventListener('change', event => {
  const input = event.target;
  if (!input.matches('.gdc-variant input')) return;
  const purchase = input.closest('[data-gdc-purchase]');
  purchase.querySelector('[data-gdc-price]').textContent = input.dataset.price;
  purchase.querySelector('[data-gdc-selected-option]').textContent = input.closest('label').querySelector('strong').textContent;
  const add = purchase.querySelector('[data-gdc-add]');
  const available = input.dataset.available === 'true';
  add.disabled = !available;
  add.textContent = available ? add.dataset.label : add.dataset.soldOut;
  purchase.querySelector('[data-gdc-buy-now]').disabled = !available;
  if (input.dataset.photo) { const image = purchase.querySelector('.gdc-selected-photo'); image.src = input.dataset.photo; image.removeAttribute('srcset'); }
  const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url);
});
document.addEventListener('submit', event => {
  const purchase = event.target.closest('[data-gdc-purchase]');
  if (!purchase) return;
  const redirect = purchase.querySelector('[data-gdc-return]');
  redirect.value = event.submitter?.matches('[data-gdc-buy-now]') ? event.submitter.dataset.checkout : '/cart';
});
})();
